import { Injectable } from '@angular/core';
import { CaqRequestService, LocalizacaoService } from '..'
import { map, firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { InformacoesEducacionaisEscolasDto, InformacoesEducacionaisMatriculasDto } from '../../dtos/informacoes-educacionais-dto';

export interface InformacoesEducacionaisMatriculasResponse {
  content: InformacoesEducacionaisMatriculasDto[];
}

export interface InformacoesEducacionaisEscolasResponse {
  content: InformacoesEducacionaisEscolasDto[];
}

export interface RespostaApi<T> {
  content: T;
}

@Injectable({ providedIn: 'root' })
export class InformacoesEducacionaisService {
  public urlBase = `${environment.apiUrl}/informacoes-educacionais`;

  constructor(
    private caqRequestService: CaqRequestService,
    private localizacaoService: LocalizacaoService
  ) { }

  async buscarNumeroEscolasLocalizacao()
    : Promise<InformacoesEducacionaisEscolasDto[]> {
    const url = this.construirUrlInformacoesEducacionais('numero-escolas');

    return firstValueFrom(
      this.caqRequestService
        .get<RespostaApi<InformacoesEducacionaisEscolasDto[]>>(url)
        .pipe(map(res => res.content))
    );
  }

  async buscarNumeroMatriculasLocalizacao()
    : Promise<InformacoesEducacionaisMatriculasDto[]> {
    const url = this.construirUrlInformacoesEducacionais('numero-matriculas');

    return firstValueFrom(
      this.caqRequestService
        .get<RespostaApi<InformacoesEducacionaisMatriculasDto[]>>(url)
        .pipe(map(res => res.content))
    );
  }

  private construirUrlInformacoesEducacionais(tipo: String): string {
    const loc = this.localizacaoService.obterLocalizacaoSelecionada();

    if (!loc) {
      return `${this.urlBase}/${tipo}/nacional`;
    }

    if (loc.cidadeSelecionada?.value) {
      const codMun = loc.cidadeSelecionada.value;
      return `${this.urlBase}/${tipo}/municipio/${codMun}`;
    }

    if (loc.estadoSelecionado?.value) {
      const codUf = loc.estadoSelecionado.value;
      return `${this.urlBase}/${tipo}/estado/${codUf}`;
    }

    return `${this.urlBase}/${tipo}/nacional`;
  }
}